import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Helper = {
    handleApiResponse(response, textSuccess = "", textError = "") {
        if (response.data.status) {
            toast.success(textSuccess, {
                autoClose: 3000,
                position: toast.POSITION.TOP_RIGHT,
            });
        } else {
            toast.error(textError, {
                autoClose: 3000,
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    },

    toast(text, type) {
        const options = {
            autoClose: 3000,
            position: toast.POSITION.TOP_RIGHT,
        };

        if (type === 'success') {
            toast.success(text, options);

        } else if (type === 'error') {
            toast.error(text, options);

        } else {
            toast.info(text, options);
        }
    }
};

export default Helper;